import Vue from 'vue'
import Router from 'vue-router'
import ContactTop from '@/components/ContactTop'
import ContactCategory2 from '@/components/ContactCategory2'
import ContactFinish from '@/components/ContactFinish'
import EntryInput from '@/components/EntryInput'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

Vue.use(Router)
Vue.use(VuejsDialog)

export default new Router({
  base: '/',
  routes: [
    {
      path: '/',
      name: 'contact_top',
      component: ContactTop
    },
    {
      path: '/category2/:category1',
      name: 'contact_category2',
      component: ContactCategory2
    },
    {
      path: '/contact_fns',
      name: 'contact_finish',
      component: ContactFinish
    },
    {
      path: '/entry/',
      name: 'entry_input',
      component: EntryInput
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js